import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  clearBasket,
  ensureBasketProducts,
} from 'apps/basket/actions/basket';
import {
  closeTrolleyMenu,
  closeRemoveAllConfirm,
  openRemoveAllConfirm,
} from 'apps/trolleyMenu/actions/trolleyMenu';

import TrolleyMenu from '../components/TrolleyMenu';

export default connect(
  state => ({
    basket: state.basket,
    betaFeatures: state.user.betaFeatures,
    deliverySlot: state.deliverySlot,
    isOpen: state.trolleyMenu.mobileTrolleyOpened,
    productsBySku: state.products.productsBySku,
    productWarnings: state.basket.productWarnings,
    removeAllConfirmOpened: state.trolleyMenu.removeAllConfirmOpened,
  }),
  (dispatch) => ({
    ...bindActionCreators({
      closeTrolleyMenu,
      ensureBasketProducts,
      onRemoveAll: openRemoveAllConfirm,
      onRemoveAllCancel: closeRemoveAllConfirm,
    }, dispatch),
    onRemoveAllConfirm: () => {
      dispatch(closeRemoveAllConfirm());
      dispatch(clearBasket());
    },
  }),
)(TrolleyMenu);
